export default __webpack_public_path__ + "static/r1-5ee11544f31ced600387a95ff63d371d.png";